import { Injectable } from "@angular/core";
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from "@angular/router";
import { Subject } from "rxjs/Subject";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./../models/auth.service";
import { UserRoles } from "../config";

@Injectable()
export class AdminAuthGuard implements CanActivate {
  private showLoader = new Subject<boolean>();

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (this.authService.isAuthorized(UserRoles.ADMIN)) {
      let permissionName = route.data["permission"];
      let permissionType = route.data["permissionType"];
      if (permissionName || permissionType) {
        this.SetLoaderStatus(true);
        return this.IsAuthorizeFor(permissionName, permissionType);
      } else {
        return true;
      }
    }

    // Store the attempted URL for redirecting
    //this.authService.redirectUrl = state.url;

    // Navigate to the login page
    this.router.navigate(["/Unauthorized"]);
    return false;
  }

  IsAuthorizeFor(permissionName: string, permissionType: string) {
    return this.authService
      .IsAuthorizeURL(permissionName, permissionType)
      .map(res => {
        this.SetLoaderStatus(false);
        if (!res.data) {
          this.router.navigate(["/NotFound"]);
        }
        return res.data;
      })
      .catch(error => {
        console.log(error);
        this.authService.HandleErrorStatusCode(error);
        this.SetLoaderStatus(false);
        return Observable.of(false);;
      });
  }

  GetLoaderStatus() {
    return this.showLoader.asObservable();
  }

  SetLoaderStatus(value: boolean) {
    this.showLoader.next(value);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/guard/auth-guard-admin.service.ts